import { render, staticRenderFns } from "./visitInquiry.vue?vue&type=template&id=ecf1b482&scoped=true&"
import script from "./visitInquiry.vue?vue&type=script&lang=js&"
export * from "./visitInquiry.vue?vue&type=script&lang=js&"
import style0 from "./visitInquiry.vue?vue&type=style&index=0&id=ecf1b482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf1b482",
  null
  
)

export default component.exports